import { PriceBand } from '@catalogue';
import { FormField } from '@forms';

export const priceBands: PriceBand[] = [
  { value: 99, label: 'under £100' },
  { value: 200, label: '£100 - £200' },
  { value: 300, label: '£200 - £300' },
  { value: 400, label: '£300 - £400' },
  { value: 500, label: '£400 - £500' },
  { value: 750, label: '£500 - £750' },
  { value: 1000, label: '£750 - £1000' },
  { value: 1500, label: '£1000 - £1500' },
];

export const manufacturerFormField: FormField = {
  fieldPlaceholder: 'Choose',
  fieldLabel: 'Manufacturer',
};

export const purchasePriceFormField: FormField = {
  fieldPlaceholder: 'Choose',
  fieldLabel: 'How much did it cost?',
};

export const wasBoughtWithin12MonthsPriceFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel: 'Did you buy it in the last 12 months?',
};

export const purchaseMonthFormField: FormField = {
  fieldPlaceholder: 'Month',
  fieldLabel: '',
};

export const purchaseYearFormField: FormField = {
  fieldPlaceholder: 'Year',
  fieldLabel: '',
};

// Pricing table for Multi-Plan
export type RiskBand = 'low' | 'high';

type PriceTable = Readonly<Record<RiskBand, Readonly<Record<number, number>>>>;

export const PRICE_TABLE: PriceTable = {
  low: {
    2: 9.50,
    3: 13.50,
    4: 17.00,
    5: 20.00,
    6: 24.00,
    7: 28.00,
    8: 32.00,
    9: 36.00,
  },
  high: {
    2: 14.00,
    3: 20.00,
    4: 25.50,
    5: 30.50,
    6: 35.00,
    7: 39.50,
    8: 44.00,
    9: 48.50,
  },
};

export function getPrice(band: RiskBand, count: number): number {
  return PRICE_TABLE[band][count];
}
